module.exports = __webpack_public_path__ + "img/icon-spinner-upload.9641b7c9.svg";